import { Component, Input, OnInit } from '@angular/core';
import { RxjsService } from '@app/shared/services/rxjs.services';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-page-spinner',
  templateUrl: './page-spinner.component.html',
  styleUrls: ['./page-spinner.component.scss']
})
export class PageSpinnerComponent implements OnInit {

  @Input() isLoading = false;

  constructor(private rxjsService: RxjsService) {
  }

  ngOnInit(): void {
    this.rxjsService.getGlobalLoaderProperty().pipe(distinctUntilChanged(), debounceTime(50)).subscribe((isLoading) => {
      this.isLoading = isLoading;
    })
  }

}
